const dummy_t = (translationKey) => translationKey;

export default [
  {
    path: '/goal-settings',
    translationKey: dummy_t('menu.dietSettings.goal'),
  },
  {
    path: '/biometric-settings',
    translationKey: dummy_t('menu.dietSettings.user'),
  },
];
